import { api_GET, api_POST, api_PUT } from "./_api.js";

const tipoAutoInfracao_api = {
    
     GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoAutoInfracao/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListByCategoria: (categoria) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoAutoInfracao/GetListByCategoria/${categoria}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (autoDeInfracao_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TipoAutoInfracao/GetItem/${autoDeInfracao_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Insert: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`TipoAutoInfracao/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, 
    Update: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`TipoAutoInfracao/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, 
}

export default tipoAutoInfracao_api;
